import React from 'react';
import {
    Card, CardFooter, CardBody,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter, 
    Button
} from 'reactstrap';

export default class CardContactosEmergencia extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    render() {

        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            <b>{this.props.nombrecontacto}</b>
                            <br />
                            <br />
                            <span className="spanCard">PARENTESCO: </span>{this.props.strNombreParentesco}
                            <br />
                            <span className="spanCard">PAÍS: </span>{this.props.strNombrePais}
                            <br />
                            <span className="spanCard">PROVINCIA: </span>{this.props.strNombreProvincia}
                            <br />
                            <span className="spanCard">DIRECCIÓN: </span>{this.props.direccioncontacto}
                            <br />
                            <span className="spanCard">EMAIL: </span>{this.props.email}
                            <br />
                            <span className="spanCard">NÚMERO TELÉFONICO: </span>+{this.props.codigopais} {this.props.codigoarea} {this.props.telefonocontacto}
                            <br />
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                            <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}